import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowLeft, ArrowRight } from '@phosphor-icons/react';
import { twMerge } from 'tailwind-merge';
import { Button, buttonStyles } from '../../atoms/Button';
import { useTestId } from '../../hooks';
import { forwardRefWithName } from '../../utils';
import { pageLinksValues } from './utils';
const FIRST_PAGE_INDEX = 1;
const SIZES = {
    mobile: 3,
    desktop: 5,
};
const WIDTHS = {
    large: 'w-14',
    medium: 'w-12',
    small: 'w-10',
    mini: 'w-8',
};
function PaginationComponent(_a, ref) {
    var { onClick, page, pages, size = 'small', mode = 'desktop', testId = 'pagination' } = _a, props = __rest(_a, ["onClick", "page", "pages", "size", "mode", "testId"]);
    const tid = useTestId(testId, props);
    // Skip pagination rendering while there is just 1 page
    if (pages === 1)
        return _jsx("div", {});
    const renderPageLinks = pageLinksValues({ page, pages, visibleButtons: SIZES[mode] }).map((pageNumber, index) => {
        if (pageNumber === -1)
            return (_jsx("div", { className: twMerge('font-roobert flex items-center justify-center select-none', buttonStyles[size].height, WIDTHS[size]), children: "..." }, `${pageNumber}${index}`));
        const isCurrentPage = page === pageNumber;
        return (_jsx(Button, Object.assign({ size: size, className: WIDTHS[size], disabled: isCurrentPage, outlined: isCurrentPage, onClick: () => (page === pageNumber ? null : onClick(pageNumber)) }, tid(`page-${pageNumber}`), { children: pageNumber }), `${pageNumber}${index}`));
    });
    return (_jsxs("div", Object.assign({ ref: ref, className: "flex items-center justify-end gap-1" }, tid(), { children: [_jsx(Button, Object.assign({ className: WIDTHS[size], onClick: () => (page === FIRST_PAGE_INDEX ? null : onClick(page - 1)), disabled: page === FIRST_PAGE_INDEX, icon: _jsx(ArrowLeft, {}), size: size }, tid('prev-button'))), renderPageLinks, _jsx(Button, Object.assign({ className: WIDTHS[size], onClick: () => (page === pages ? null : onClick(page + 1)), disabled: page === pages, icon: _jsx(ArrowRight, {}), size: size }, tid('next-button')))] })));
}
export const Pagination = forwardRefWithName(PaginationComponent);
//# sourceMappingURL=Pagination.js.map